// extracted by mini-css-extract-plugin
module.exports = {"send_to_campaign_row":"MessageElement__send_to_campaign_row___2_2i2","gallery_element":"MessageElement__gallery_element___YABJQ"};